export default __webpack_public_path__ + "static/media/11.blur.70301428.jpeg";